import { MessageFormatElement } from 'intl-messageformat-parser';

const messages: Record<string, string> | Record<string, MessageFormatElement[]> = {
    closePage: "Close the page",
    successStatus: "The payment was successful",
    successStatusInfo: "Thank you. You don't have to do anything anymore and you can close the page.",
    failedStatus: "The payment failed.",
    failedStatusInfo: "What now? You can always try the payment link in our mail again. You could also try another payment method.",
    pendingStatus: "The payment is pending...",
    pendingStatusInfo: "Please do not close this page or refresh, you will be forwarded shortly."
}

export default messages;